import React from "react";
import "../Pricelist/Price.css";
import Pricelist from "./Pricelist";
const Price = () => {
  return (
    <>
      <div className="poster-section">
        <img src="price.webp" alt="Poster" className="poster-image" />
      </div>
      <Pricelist />
    </>
  );
};

export default Price;
